module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0142.jpg?v=ecea0d00";